import React from 'react';

const SvgStandard: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="-4 -4 24 24"
    {...props}
  >
    <path
      fill="#5A636B"
      d="M2.928 14.5v-1.147H13V14.5H2.928Zm-.022-2.441-1.041-5.99a1.365 1.365 0 0 1-.172.02.955.955 0 0 1-.706-.29.962.962 0 0 1-.287-.703c0-.28.096-.518.287-.714a.949.949 0 0 1 .706-.294.97.97 0 0 1 .713.294.972.972 0 0 1 .294.714c0 .07-.006.137-.018.198a.72.72 0 0 1-.056.172l2.42 1.027 2.33-3.181a.98.98 0 0 1-.419-.805c0-.28.098-.517.294-.713a.97.97 0 0 1 .713-.294c.28 0 .518.098.714.293a.969.969 0 0 1 .294.713.984.984 0 0 1-.42.806l2.332 3.18 2.419-1.026a1.378 1.378 0 0 1-.052-.172.984.984 0 0 1 .264-.912.949.949 0 0 1 .707-.294c.28 0 .518.098.714.294a.972.972 0 0 1 .293.714.95.95 0 0 1-.294.702.98.98 0 0 1-.715.29.346.346 0 0 1-.075-.01.37.37 0 0 0-.083-.009l-1.039 5.99H2.906Z" // eslint-disable-line max-len
    />
  </svg>
);

export default SvgStandard;
